export default __webpack_public_path__ + "static/media/darkspinner-unscreen.e552a5e8.gif";